/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Kanban_Locked_TitleInputs */



/**
* | output |
* | --- |
* | "Locked Project" |
*
* @param {Explorer_Kanban_Locked_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_locked_title = /** @type {((inputs?: Explorer_Kanban_Locked_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Locked_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Projet verrouille")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesperrtes Projekt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progetto bloccato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект заблокирован")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto bloqueado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已锁定项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ロックされたプロジェクト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लॉक किया गया प्रोजेक्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto bloqueado")
	return /** @type {LocalizedString} */ ("Locked Project")
});